import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=9d6b4fa6&scoped=true&"
import script from "./GoTop.vue?vue&type=script&lang=js&"
export * from "./GoTop.vue?vue&type=script&lang=js&"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=9d6b4fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6b4fa6",
  null
  
)

export default component.exports